import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { RiCheckboxCircleLine } from '@/shared/icons/remix'
import {
  SURVEY_SUBMIT_SUCCESS_BODY,
  SURVEY_SUBMIT_SUCCESS_OK,
  SURVEY_SUBMIT_SUCCESS_TITLE,
} from '../../lib/survey-completion-messages'
import {
  surveySubmitSuccessActionsSx,
  surveySubmitSuccessBodySx,
  surveySubmitSuccessDialogContentSx,
  surveySubmitSuccessDialogPaperSx,
  surveySubmitSuccessIconCircleSx,
  surveySubmitSuccessIconWrapSx,
  surveySubmitSuccessOkButtonSx,
  surveySubmitSuccessTitleSx,
} from '../../styles/surveyExecutionStyles'

interface SurveySubmitSuccessDialogProps {
  readonly open: boolean
  readonly onConfirm: () => void
}

/** Figma 5074-14008 — confirmation after final answer save. */
export function SurveySubmitSuccessDialog({ open, onConfirm }: SurveySubmitSuccessDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onConfirm}
      aria-labelledby="survey-submit-success-title"
      data-testid="survey-submit-success-dialog"
      PaperProps={{ sx: surveySubmitSuccessDialogPaperSx }}
    >
      <DialogContent sx={surveySubmitSuccessDialogContentSx}>
        <Box sx={surveySubmitSuccessIconWrapSx}>
          <Box sx={surveySubmitSuccessIconCircleSx} aria-hidden>
            <RiCheckboxCircleLine size={31} />
          </Box>
        </Box>
        <Typography
          id="survey-submit-success-title"
          component="h2"
          sx={surveySubmitSuccessTitleSx}
        >
          {SURVEY_SUBMIT_SUCCESS_TITLE}
        </Typography>
        <Typography component="p" sx={surveySubmitSuccessBodySx}>
          {SURVEY_SUBMIT_SUCCESS_BODY}
        </Typography>
        <Box sx={surveySubmitSuccessActionsSx}>
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={surveySubmitSuccessOkButtonSx}
            data-testid="survey-submit-success-ok"
          >
            {SURVEY_SUBMIT_SUCCESS_OK}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
